import React, { type ReactNode } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { AuthProvider, Logout } from "./account";
import Navigation from "./components/navigation/Navigation";
import { UTLSettingsProvider } from "./context/UTLSettingContext";
import { AssetProvider } from "./context/assetContext";
import { UserProvider } from "./context/userContext";
import "./css/index.css";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
import { ConfigurationsType } from "./configurationMenu";
import { ContextMenuMESFProvider, ShiftNavigatorProvider } from "./controls";
import {
	ConfigurationContext,
	NavbarContext,
	RouterContext,
} from "./globalContext";
import { TimeService } from "./services";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

const base =
	document.getElementsByTagName("base")[0].getAttribute("href") || "/";

interface Props {
	authentication: any;
	routes: ReactNode;
	navbar: ReactNode;
	navbarTitle?: string;
	configurations: ConfigurationsType;
	showAreaSelector?: boolean;
	showTrendingsIcon?: boolean;
}

function MESFMain({
	authentication,
	routes,
	navbar,
	navbarTitle = "MESF",
	configurations,
	showAreaSelector = false,
	showTrendingsIcon = true,
}: Props) {
	return (
		<AuthProvider authConfig={authentication}>
			<LocalizationProvider
				dateAdapter={AdapterMoment}
				dateLibInstance={moment}
			>
				<UserProvider>
					<AssetProvider>
						<UTLSettingsProvider>
							<RouterContext.Provider value={routes}>
								<NavbarContext.Provider value={navbar}>
									<ConfigurationContext.Provider value={configurations}>
										<ShiftNavigatorProvider>
											<ContextMenuMESFProvider>
												<Router basename={base}>
													<Routes>
														<Route path="/logout" element={<Logout />} />
													</Routes>
													<Navigation
														showAreaSelector={showAreaSelector}
														showTrendingsIcon={showTrendingsIcon}
														navbarTitle={navbarTitle}
													/>
												</Router>
											</ContextMenuMESFProvider>
										</ShiftNavigatorProvider>
									</ConfigurationContext.Provider>
								</NavbarContext.Provider>
							</RouterContext.Provider>
						</UTLSettingsProvider>
					</AssetProvider>
				</UserProvider>
			</LocalizationProvider>
		</AuthProvider>
	);
}

export { MESFMain };
